<template>
    <div class="content-box">
        <div class="element-wrapper pb-0">
            <div class="element-header">
                <div class="row">
                    <div class="col-md 8 mr-auto">
                        <h3 class>Global - Detalhes Clientes</h3>
                    </div>
                     <div class="col-auto">
                        <b-button @click="voltar">Voltar</b-button>
                    </div>
                </div>
            </div>
        </div>
         <div class="">
          <div class="text-right">
            <b-button v-b-toggle.collapse-1 variant="primary">
                <i class="fa fa-filter"></i>
                Filtros 
            </b-button>
          </div>
          <b-collapse id="collapse-1" class="mt-2">
            <b-card header="Filtros para aplicar">
              <div class="container">
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label>Empresa</label>
                      <multiselect 
                        v-model="filtro.empresa"
                        :multiple="true"
                        label="name"
                        value="_id"
                        track-by="_id"
                        placeholder="Selecione uma empresa"
                        :showLabels="false"
                        :options="empresas"
                        ></multiselect>    
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label> Data Emissão Inicial:</label>
                      <datepicker 
                      calendar-button-icon="fa fa-calendar-alt" 
                      clear-button
                      :disabled-dates="disabledData"
                      bootstrap-styling 
                      calendar-button 
                      v-model="filtro.dataEmissaoInicial"
                      >
                      </datepicker>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label> Data Emissão Final:</label>
                        <datepicker
                        calendar-button-icon="fa fa-calendar-alt" 
                        clear-button 
                        :disabled-dates="disabledData"
                        bootstrap-styling 
                        calendar-button 
                        v-model="filtro.dataEmissaoFinal">
                        </datepicker>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                      <div class="form-group">
                          <label>Data Vencimento Inicial:</label>
                              <datepicker 
                              calendar-button-icon="fa fa-calendar-alt" 
                              clear-button
                              :disabled-dates="disabledData"
                              bootstrap-styling 
                              calendar-button 
                              v-model="filtro.dataVencimentoInicial">
                              </datepicker>
                      </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                        <label>Data Vencimento Final:</label>
                            <datepicker 
                            calendar-button-icon="fa fa-calendar-alt" 
                            clear-button
                            :disabled-dates="disabledData"
                            bootstrap-styling 
                            calendar-button 
                            v-model="filtro.dataVencimentoFinal">
                            </datepicker>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                      <div class="form-group">
                          <label> Data Pagamento Inicial:</label>
                              <datepicker 
                              calendar-button-icon="fa fa-calendar-alt" 
                              clear-button 
                              :disabled-dates="disabledData"
                              bootstrap-styling 
                              calendar-button 
                              v-model="filtro.dataPagamentoInicial"></datepicker>
                      </div>
                  </div>
                  <div class="col-4">
                      <div class="form-group">
                          <label>Data Pagamento Final:</label>
                              <datepicker 
                              calendar-button-icon="fa fa-calendar-alt" 
                              clear-button 
                              :disabled-dates="disabledData"
                              bootstrap-styling 
                              calendar-button 
                              v-model="filtro.dataPagamentoFinal"></datepicker>
                      </div>
                  </div>
                </div>
                  <div class="row text-right">
                    <div class="col">
                      <b-link @click="limpar" class="mr-2">Limpar</b-link>
                      <b-button v-b-toggle.collapse-1 @click="find" variant="primary">Aplicar</b-button>
                    </div>
                  </div>
              </div>
            </b-card>
          </b-collapse>
        </div>
        <div class="col" style="margin:10px">
            <div class="element-wrapper pb-0">
                <b-card>
                    <div class="container">
                        <div class="row">
                            <div class="col">
                                <label for>Total Clientes</label>
                                <h5>{{resultado.qtdClientes}}</h5>
                            </div>
                            <div class="col">
                                <label for>Clientes Pago</label>
                                <h5>{{resultado.qtdClientesPagos}}</h5>
                            </div>
                            <div class="col">
                                <label for>Clientes Inadiplente</label>
                                <h5>{{resultado.qtdClientesInadiplementes}}</h5>
                            </div>
                        </div>
                    </div>
                </b-card>
            </div>
        </div>
            <div class="mt-3">
                <b-card>
                    <div class="row">
                        <b-col class="my-1">
                        <b-pagination
                            v-if="totalRows > 10"
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                            class="my-0"
                        ></b-pagination>
                        </b-col>
                    </div>
                    <b-table show-empty emptyText="Não há itens para exibir"
                    ref="table" id="my-table"
                    :current-page="currentPage"
                    :per-page="perPage" selectable
                    @row-selected="onRowSelected"
                    select-mode="single"
                    selected-variant="success"
                    :busy="loading" :items="detalhesClientes" sticky-header
                    :fields="fields" small
                    striped hover bordered>
                        <div slot="table-busy" class="text-center my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                        </div>
                        <template slot="[formadePagamento]" slot-scope="row">
                        <b-badge variant="warning">{{getTextFormaPagamento(row.item.formaPagamento)}}</b-badge>
                        </template>
                        <template slot="[plano]" slot-scope="row">
                          {{row.item.pedido.plano.name}} - {{row.item.pedido.plano.price | money }}
                        </template>
                        <template slot="[statusFatura]" slot-scope="row">
                            <b-badge :variant="getTextSatusFatura(row.item)=== 'Pago' ? 'success' : 'warning'">{{getTextSatusFatura(row.item)}}</b-badge>
                        </template>
                        <template slot="[actions]" slot-scope="row">
                        <b-button title="Visualizar" variant="light" @click.stop=" $router.push({name: 'PedidoDetail', query:{id: row.item.pedido._id}})">
                            <i class="fas fa-search"></i>
                        </b-button>
                        </template>
                    </b-table>
                </b-card>
            </div>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';
import { Validator } from "vee-validate";
import utils from "@/utils";

export default {
  async mounted(){
    const empresa = await axios.get(`/api/juridica/?select=name%20_id`);
    this.empresas = empresa.data
    this.filtro.dataEmissaoInicial = moment().subtract("1","month").toDate();
    this.filtro.dataEmissaoFinal = moment().toDate()
    this.find();
  },
  computed: {
    formasPagamento() {
        return this.$store.getters.formasPagamento;
    },
    statusCobranca () {
        return this.$store.getters.statusCobranca;
    },
    statusPedido() {
        return this.$store.getters.statusPedido;
    },
    exibicaoFiltro() {
        return this.$store.getters.exibicaoFiltro;
    },
    filtro() {
      return this.$store.getters.filtro;
    }
  },
  created() {
    Validator.extend("cpf", {
      getMessage: () => "CPF inválido",
      validate: value => {
        return !!utils.TestaCPF(value);
      }
    });
  },
  components: {
    datepicker,
    Multiselect
  },
  data(){
    var dataInicial = moment().toDate();
    var dataFinal = moment().subtract("2","month").startOf("month").toDate();
    return {
        resultado:{},
        empresas:[],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        items: [],
        table:[],
        disabledData:{
          to:dataFinal,
          from:dataInicial
        },
        fields: [
        {key: 'pedido.createdAt', label: 'Data Criação', sortable: true, formatter: this.createdAtFormatter},
        {key: 'pedido.idPedidoVindi', label: 'ID', sortable: true}, 
        {key: 'pedido.client.cpf', label: 'CPF'}, 
        {key: 'pedido.client.name', label: 'Nome'},
        {key: 'plano', label: 'Plano', sortable: true},
        {key: 'formadePagamento', label: 'Método Pagamento', sortable: true},
        {key: "vindiInfo.period.start_at", label:"Data Emissão Fatura", sortable: true,formatter:this.createdAtFormatter},
        {key: "vindiInfo.due_at", label:"Data Vencimento Fatura", sortable:true,formatter:this.createdAtFormatter},
        {key: "statusFatura", label:"Status da Fatura", sortable: true},
        {key: 'actions', label: ''}
        ],
    }
  },
  methods:{
    voltar() {
      window.history.back();
    },
    limpar() {
      this.filtro = {}
      this.mostrarFiltros={}
    },
    async find() {
      this.$store.dispatch("setLoading",true);
      this.$root.$emit('bv::refresh::table', 'my-table')
      this.$store.dispatch("setLoading",false);
    },
    createdAtFormatter(value){
      if (value) {
        return moment(value).format("DD/MM/YYYY");
      }
      return ''
    },
    async detalhesClientes(ctx){
      this.currentPage = ctx.currentPage;

      await this.$store.dispatch('setFiltro', this.filtro);

      const resposta = await this.$store.dispatch('findDetalhesCliente')
      const resultado = resposta.data;
      this.resultado = {
          qtdClientes:resultado.qtdClientes,
          qtdClientesInadiplementes:resultado.qtdClientesInadiplementes,
          qtdClientesPagos:resultado.qtdClientesPagos,
          qtsClientesAguardandoPagamento: resultado.qtsClientesAguardandoPagamento
      }
      const table = resultado.faturasFinal.data;
      
      return table;
    }, 
    onRowSelected(items) {
      let pedido = items[0].pedido;
      this.$router.push({name: 'PedidoDetail', query:{id: pedido._id}});
    },
    getTextFormaPagamento(formaPagamento) {
      switch (formaPagamento) {
        case 'cartaoCredito':
          return 'Cartão Crédito'
        default:
          return formaPagamento;
      }
    },
    getTextSatusFatura(fatura){
        const faturaAtualizada = fatura.vindiInfo
        const vencimento = moment().isSameOrAfter(faturaAtualizada.due_at);
        switch(faturaAtualizada.status){
            case "paid":
                return "Pago";
            case "pending":
                if(fatura.dataPagamento){
                  return "Paga";
                }
                else if(vencimento){
                    return "Vencida";
                }else{
                  return "Aguardando Pagamento";
                }
            case 'processing':
                if(fatura.dataPagamento){
                  return "Paga";
                }
                else if(vencimento){
                    return "Vencida";
                }else{
                  return "Aguardando Pagamento";
                }
            case 'reject':
                return "Rejetado"
            default:
                return ""
        }
    }
  }
}
</script>